import React from "react";
import RequestedList from "../../Lab Admin Tabs/RequestedList/RequestedList";

// Empty file
const AnalystRequestedList = ({ TabConfig }) => {
  return <RequestedList TabConfig={TabConfig} />;
};

export default AnalystRequestedList;
